import React, { useEffect, useState } from 'react';
import { getApmcByDepartmentId, getExistedSchemesAplication, submitApmcFiles } from '../../../../auth/services/privateapicalling';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { toast, ToastContainer } from 'react-toastify';
import RejPage from './RejPage';

// Define props interface for better type safety
interface DistrictAllFormsProps {
  unverifiedFields?: string[];
  userRole?: string;
  existData?: any;
  prepareRejectedField?:()=>void;
  commentsubmitted?:boolean;
}

const DistrictAllForms: React.FC<DistrictAllFormsProps> = ({ 
  unverifiedFields = [], 
  userRole, 
  existData: parentExistData ,
  prepareRejectedField,
  commentsubmitted
}) => {
  const token = useSelector((state: any) => state.auth.token);
  const userDetail = useSelector((state: any) => state.auth.userDetails);
  const location = useLocation();
  
  const applicationId = location.state?.applicationId;
  const id = location.state?.id;
  const type = location.state?.type || null;


  const [existData, setExistData] = useState<any | null>(parentExistData || null);
  const [transaction, setTransaction] = useState<any[]>([]);
  const [step, setStep] = useState<number>(1);
  const [formData, setFormData] = useState<Record<string, Array<Record<string, any>>>>({});
  const [editFieldValues, setEditFieldValues] =  useState<Record<string, Array<Record<string, any>>>>({});
  const [editFiles, setEditFiles] =  useState<Record<string, Array<Record<string, any>>>>({});
  const [resubmittedFields, setResubmittedFields] = useState<any>({
   
  });
   const [uploadLoading, setUploadLoading]=useState(false);
  const [validationErrors, setValidationErrors] = useState<{ [key: string]: string }>({});
  const [isValidating, setIsValidating] = useState(false);
  const [districtOptions, setDistrictOptions] = useState<any[]>([]);

  // Function to get existing application data
  const getExistedApplication = async () => {
    try {
   
      const response = await getExistedSchemesAplication(token, applicationId, id);
     
      
      if (response?.success) {
        
        setExistData(response?.data);
        setTransaction(response?.data?.ApmcSchemeTransaction || []);
      }
    } catch (error) {
    
    }
  };

  // Initialize with parent data if available, otherwise fetch
  useEffect(() => {
    if (parentExistData) {
      setExistData(parentExistData);
      setTransaction(parentExistData?.ApmcSchemeTransaction || []);
    } else {
      getExistedApplication();
    }
  }, [parentExistData]);

  // Fetch application data on component mount if no parent data
  useEffect(() => {
    if (!parentExistData) {
      getExistedApplication();
    }
  }, []);

  // Handle file changes
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, fieldName: string) => {
   
    const { name, files } = e.target;

    
    if (files && files.length > 0) {
      const file = files[0];
      const fileName = file.name;
      let docId: any;
      
      const userData = existData?.annexureOne?.[fieldName]?.transaction?.find(
        data => data.transactionBy == userDetail.Role.Role_Identifier
      );
      
    
      
      if (userData) {
     
        const docData = userData?.newValue.find(data => data?.fieldName == name);
      
        docId = docData?.fieldValue ? docData.fieldValue : null;
        
      }
      
  
      handleUpload(name, file, fieldName, docId, fileName);
    }
  };

  // Handle file upload
  const handleUpload = async (
    documentName: string,
    file: any,
    fieldName: string,
    docId?: string | null,
    fileName?: string,
    annexureType?:string
  ) => {
    const formDataUpload = new FormData();
    formDataUpload.append("file", file);
    formDataUpload.append("documentName", documentName);
    formDataUpload.append("fieldName", fieldName);
    formDataUpload.append("applicationId", applicationId);
    formDataUpload.append("schemeId", id);
setUploadLoading(true)
    try {
      const res = await submitApmcFiles(formDataUpload, token, docId);
     

      if (res.success === false) {
        toast.error(res?.message || "File upload failed", {
          position: "top-right",
          autoClose: 3000
        });
      } else if (res.success && res.docId) {
        if(userRole==="SEC"){
        setResubmittedFields(prev => {
      const arr = Array.isArray(prev[fieldName]) ? [...prev[fieldName]] : [];
     const index = arr.findIndex(item => item.documentName === documentName);
if (index !== -1) {
  arr[index] = { docId: res?.docId, documentName: documentName, fileName: fileName };
} else {
  arr.push({ docId: res?.docId, documentName: documentName, fileName: fileName });
}
      return { ...prev, [fieldName]: arr };
    });
        
        }else
       {
         
              setEditFiles(prev => {
             const arr = Array.isArray(prev[fieldName]) ? [...prev[fieldName]] : [];
            const index = arr.findIndex(item => item.documentName === documentName);
       if (index !== -1) {
         arr[index] = { docId: res?.docId, documentName: documentName, fileName: fileName };
       } else {
         arr.push({ docId: res?.docId, documentName: documentName, fileName: fileName });
       }
             return { ...prev, [fieldName]: arr };
           });
              
             }
        toast.success("File uploaded successfully", {
          position: "top-right",
          autoClose: 3000
        });
      }
    } catch (error) {
      toast.error("File upload failed");
    }finally{
      setUploadLoading(false)
    }
  };

  // Handle input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, fieldName?: string) => {
    const { name, value } = e.target;
    
   if (fieldName) {
    setEditFieldValues(prev => {
      const arr = Array.isArray(prev[fieldName]) ? [...prev[fieldName]] : [];
      const index = arr.findIndex(item => item.fieldName === name);
      if (index !== -1) {
        arr[index] = { ...arr[index], value: value };
      } else {
        arr.push({ value: value, fieldName: name });
      }
      return { ...prev, [fieldName]: arr };
    });
  } else {
    // Optionally handle case when fieldName is not provided
  }
  };

  // Resubmission handlers
  const handleResubmissionInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, fieldName: string, annexureType: string) => {
     const { name, value } = e.target;
    setResubmittedFields(prev => {
      const arr = Array.isArray(prev[fieldName]) ? [...prev[fieldName]] : [];
      const index = arr.findIndex(item => item.fieldName === name);
      if (index !== -1) {
        arr[index] = { ...arr[index], value: value };
      } else {
        arr.push({ value: value, fieldName: name });
      }
      return { ...prev, [fieldName]: arr };
    });
    // setValidationErrors((prev) => ({ ...prev, [`${annexureType}_${fieldName}`]: "" }));
  };

  const handleResubmissionPercentageChange = (e: React.ChangeEvent<HTMLInputElement>, fieldName: string, annexureType: string) => {
     const { name, value } = e.target;
    // Optionally add validation for percentage
 setResubmittedFields(prev => {
      const arr = Array.isArray(prev[fieldName]) ? [...prev[fieldName]] : [];
      const index = arr.findIndex(item => item.fieldName === name);
      if (index !== -1) {
        arr[index] = { ...arr[index], value: value };
      } else {
        arr.push({ value: value, fieldName: name });
      }
      return { ...prev, [fieldName]: arr };
    });
    setValidationErrors((prev) => ({ ...prev, [`${annexureType}_${fieldName}`]: "" }));
  };

  const handleResubmissionFileChange = (e: React.ChangeEvent<HTMLInputElement>, fieldName: string, annexureType: string) => {
const { name, files } = e.target;
    if (!files) return;
       if (files && files.length > 0) {
      const file = files[0];
      const fileName = file.name;
      // let docId: any;
       const docData = existData?.annexureOne?.[fieldName];
    const docId = docData?.data.find(
      (data) => data.documentName == name
    )?.docId;
      handleUpload(name, file, fieldName, docId, fileName,annexureType);
       }
    // setResubmittedFields((prev: any) => ({
    //   ...prev,
    //   [annexureType]: {
    //     ...prev[annexureType],
    //     [fieldName]: {
    //       data: [{ fileName: files.name, file }]
    //     }
    //   }
    // }));
    // setValidationErrors((prev) => ({ ...prev, [`${annexureType}_${fieldName}`]: "" }));
  };

  // const clearValidationError = (key: string) => {
  //   setValidationErrors((prev) => {
  //     const newErrors = { ...prev };
  //     delete newErrors[key];
  //     return newErrors;
  //   });
  // };

  useEffect(() => {
    // Additional logic if needed when step changes
  }, [step]);

  // Helper function to check if a field is unverified
  const isFieldUnverified = (fieldName: string) => {
    return unverifiedFields.includes(fieldName);
  };

  // Helper function to get field status
  const getFieldStatus = (fieldName: string) => {
    if (!existData?.annexureOne?.[fieldName]) return null;
    
    const fieldData = existData.annexureOne[fieldName];
    if (fieldData?.transaction && Array.isArray(fieldData.transaction)) {
      const lastTransaction = fieldData.transaction[fieldData.transaction.length - 1];
      return {
        isVerified: lastTransaction?.isVerified,
        comment: lastTransaction?.comment,
        status: lastTransaction?.status
      };
    }
    return null;
  };

  return (
    <div>

      {/* Step Form Display */}
      {step === 1 && (
        <RejPage
          editFieldValues={editFieldValues}
          setEditFieldValues={setEditFieldValues}
          editFiles={editFiles}
          setEditFiles={setEditFiles}
          formData={formData}
          setFormData={setFormData}
          handleFileChange={handleFileChange}
          handleInputChange={handleInputChange}
          type={id}
          existData={existData}
          applicationId={applicationId}
          formType={type}
          transaction={transaction}
          getExistedApplication={getExistedApplication}
          // Pass additional props for handling unverified fields
          unverifiedFields={unverifiedFields}
          userRole={userRole}
          isFieldUnverified={isFieldUnverified}
          getFieldStatus={getFieldStatus}
          resubmittedFields={resubmittedFields}
          setResubmittedFields={setResubmittedFields}
          validationErrors={validationErrors}
          prepareRejectedField={prepareRejectedField}
        //   isValidating={isValidating}
          districtOptions={districtOptions}
          handleResubmissionInputChange={handleResubmissionInputChange}
          handleResubmissionPercentageChange={handleResubmissionPercentageChange}
          handleResubmissionFileChange={handleResubmissionFileChange}
          uploadLoading={uploadLoading}
          commentsubmitted={commentsubmitted}
        //   clearValidationError={clearValidationError}
        />
      )}

      <ToastContainer position='top-left' autoClose={3000} />
    </div>
  );
};

export default DistrictAllForms;